import {Dce, DceComponent, DceHTMLElement} from "dce-engine";

interface ScrollMenuProps {

}

const breakpoints = {
    'xs' : 420,
    'sm' : 576,
    'md' : 768,
    'lg' : 992,
    'xl' : 1200,
    'xxl':  1400,
}

@Dce("ScrollMenu")
export default class ScrollMenu extends DceComponent<ScrollMenuProps> {
    private iframe: HTMLIFrameElement;

    private scrollTop: number;

    constructor(elem: DceHTMLElement, props: ScrollMenuProps) {
        super(elem, props);

        const scroll = sessionStorage.getItem('_menu');

        if (scroll !== null) {
            elem.scrollTop = parseInt(scroll, 10);
        }


        elem.addEventListener('scroll', () => {
            this.scrollTop = elem.scrollTop;
            //sessionStorage.setItem(storageKey, menu.scrollTop);
        });

        window.addEventListener('pagehide', () => {
            sessionStorage.setItem('_menu', String(this.scrollTop));
        });

    }

}
